module.exports = __webpack_public_path__ + "img/CF.675a70c6.png";